<template>
    <div class="card mb-3 h-100">
        <div class="card-body">
            <Shipping :shipping_status="shippings"/>
            <p>{{shippings[0].service_code}} - {{ shippings[0].service_description }} </p>
            <p v-if="shippings[0].deadline">{{ shippings[0].deadline }}</p>
            <p>Valor: {{ shippings[0].amount | money }}</p>
            <p v-if="shippings[0].tracking_code">Código de Rastreio: {{ shippings[0].tracking_code }}</p>
            <button v-if="shippings[0].status === 1 || shippings[0].status === 4 || shippings[0].status === 5 || shippings[0].status === 9" type="button" class="btn btn-success btn-sm btn-adjustment" data-target="#shippingCode" data-toggle="modal"><i class="fas fa-sync-alt mr-2"></i> Atualizar</button>
            <button v-if="shippings[0].status === 1 || shippings[0].status === 4" type="button" class="btn ml-2 btn-success btn-adjustment" data-target="#shippingCodeChangeStatus" data-toggle="modal"><i class="fas fa-boxes"></i></button>
            <!-- <p>Obs.: {{ shippings[0].comments }}</p> -->
        </div>
        <!-- Modal do Código de Rastreio -->
        <div class="modal mt-5" id="shippingCode" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row py-3">
                  <div v-if="shippings[0].status === 1" class="col">
                    <label for="" class="control-label">Código de Rastreio</label>
                    <input type="text" placeholder="Ex.: 0X1Y2Z" v-model="data.shipping_code" class="form-control">
                    <span v-if="error" class="text-danger">{{ error }}</span>
                  </div>
                  <div v-if="shippings[0].status === 4" class="col">
                    <label for="" class="control-label">Pedido em Rota?</label>
                  </div>
                  <div v-if="shippings[0].status === 5" class="col">
                    <label for="" class="control-label">Pedido Entregue?</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button type="button" class="btn btn-success w-100" @click="save()">Atualizar Pedido</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal que atualiza o status para 'Em Separação -->
        <div class="modal mt-5" id="shippingCodeChangeStatus" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row py-3">
                  <div class="col-12">
                    <label for="" class="control-label">Deseja alterar o status de entrega do pedido para '<b>Em Separação</b>'?</label>
                  </div>
                  <div class="col-12">
                    <span class="text-danger fs-1"><b>Obs: Não será enviado nenhum e-mail para o cliente</b></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button type="button" class="btn btn-success w-100" @click="changeStatus()">Atualizar status</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import ShippingStatusComponent from '../components/ShippingStatusComponent.vue'
import { mapActions, mapState } from 'vuex'

export default {

  components: {
    Shipping: ShippingStatusComponent
  },

  computed: mapState({
    error: state => state.shippings.error,
    data: state => state.shippings.data
  }),

  props: ['shippings', 'client'],

  methods: {

    ...mapActions('shippings', [
      'store',
      'edit'
    ]),

    save () {
      let status

      if (this.shippings[0].status === 1) {
        status = 4
      } else if (this.shippings[0].status === 4) {
        status = 5
        this.data.shipping_code = null
      } else if (this.shippings[0].status === 5) {
        status = 6
        this.data.shipping_code = null
      }

      this.store({
        id: this.client.id,
        status: status,
        shipping_code: this.data.shipping_code
      })
    },

    changeStatus () {
      this.edit({
        id: this.client.id,
        shipping_id: this.shippings[0].id
      })
    }
  }
}
</script>

<style scoped>
    .my-card-title {
        font-size: 23px !important;
    }
    .btn-adjustment {
      font-size: 11px !important;
      padding: 4px 12px !important;
    }
</style>
